var map = {
	"./placeholder-0.svg": 621,
	"./placeholder-1.svg": 622,
	"./placeholder-2.svg": 623,
	"./placeholder-3.svg": 624,
	"./placeholder-4.svg": 625,
	"./placeholder-5.svg": 626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 620;